module.exports = __webpack_public_path__ + "img/FAS_FantasyShield.010474d5.png";